import {
  bindClaimApplicantData,
  bindClaimAttachmentsData,
  bindClaimInsuredPersonData,
  bindClaimPayloadData,
  bindPaymentReceiverData,
  formatDate,
} from '../claimApplicationHelpers';
import { TRANSFER_TYPES } from '../../../constants';

// eslint-disable-next-line import/prefer-default-export
export const prepareMedicalPayload = (data) => {
  const {
    personalData,
    accidentInfo,
    compensation,
    conclusion,
    attachments: formAttachments,
    language,
  } = data;

  const insuredPerson = bindClaimInsuredPersonData(personalData);
  const applicant = bindClaimApplicantData(personalData);
  const payload = bindClaimPayloadData(personalData, applicant, language);

  payload.insuredPerson = insuredPerson;

  payload.accidentDate = formatDate(accidentInfo.accidentDate);
  payload.contractNumber = accidentInfo.contract.policyNumber;
  payload.insuredOrganizationName = accidentInfo.contract.insurer;
  payload.damageCost = accidentInfo.damageAmount;
  payload.currency = accidentInfo.currency;
  payload.accidentInformation = accidentInfo.accidentInformation;

  payload.transferType = compensation.transferType;
  payload.transferBank = compensation.transferBank;
  payload.transferAccount = compensation.transferType === TRANSFER_TYPES[1].value
    ? compensation.transferAccount : null;

  const paymentReceiver = bindPaymentReceiverData(compensation, language);

  payload.paymentReceiverIs = compensation.paymentReceiverType;

  payload.paymentReceiver = paymentReceiver;

  payload.email = conclusion.email;
  payload.emailConfirmation = conclusion.emailConfirmation;
  payload.phone = conclusion.phone || null;
  payload.cellPhone = conclusion.cellPhone || null;

  payload.attachments = bindClaimAttachmentsData(formAttachments);

  payload.language = language;

  return payload;
};
